
<a *ngIf="!hasUser" class="login" routerLink="/login" routerLinkActive="active" mat-menu-item>
    Login <mat-icon class="login-icon">login</mat-icon>
</a>